export default __webpack_public_path__ + "static/media/complementary--priority-route-at-intersection--g6.9b72a153.png";